import SubscriptionProxyHandler from "@mrwa/rime-replacement/infrastructure/subscriptionProxy";

class CoordinateListState {
  constructor() {
    this._savedCoordinates = [];
  }

  get savedCoordinates() {
    return this._savedCoordinates;
  }
  set savedCoordinates(value) {
    this._savedCoordinates = value;
  }
}

export default new Proxy(
  new CoordinateListState(),
  new SubscriptionProxyHandler()
);
